import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    TableActionIconView, TableActionIconActivate,
} from "./BaseTableComponents";

import './Table.scss'

const BlockedUsersTable = (props) =>
{
    const onClickItem = (user_id, mode, role, name, blocked_by_idusers) =>
    {
        props.clickHandler(user_id,  mode, role, name, blocked_by_idusers);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <TableActionIconActivate text="Unblock User" onClick={() => onClickItem(row.idusers,'unblock',  row.typeName, row.blocked_by, row.blocked_by_idusers)} />
                <TableActionIconView text="View User" onClick={() => onClickItem(row.idusers,'view',  row.typeName)} />
            </Fragment>
        );
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        let color = "#216C06";

        if (cell === "Suspended" || cell === "Expired") {
            color = "#E00909";
        }

        if (cell === "Invited" || cell === "Re-invited") {
            color = "#E1720B";
        }

        return <div style={{ borderRadius: "5px", color: color }}>{cell}</div>;
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        blocked_user: {borderRadius: defaultTopLeftCellStyle, width: "15vw"},
        blocked_by: { width: "15vw"},
        status: {width: "10vw"},
        typeName: {width: "10vw"},
        blocked_date: {width: "10vw"},
        options: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "15vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "blocked_user",
                text: "Blocked User",
                headerStyle: headerStyle
            },
            {
                dataField: "status",
                text: "Status",
                formatter: statusFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "blocked_by",
                text: "Blocked By",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "typeName",
                text: "User Type",
                formatter: statusFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "blocked_date",
                text: "Blocked Date",
                headerStyle: headerStyle
            },
            {
                dataField: "options",
                text: "Options",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default BlockedUsersTable;

BlockedUsersTable.propTypes = {
    user_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};
